import { ICreateManutencaoUseCase } from "../../../presentation/useCases/create/create_manutencao_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * CreateManutencaoUseCase
 */

export class CreateManutencaoUseCase implements ICreateManutencaoUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async execute(
    nroManutencao?: number,
    idManutencao?: number,
    status?: string,
    idCentroCusto?: number,
    idMaquinaEquip?: number,
    idFuncionarioSolicitante?: number,
    idFuncionarioAprovacao?: number,
    idFornecedorResponsavel?: number,
    valorOrcamento?: number,
    dataPrevConclusao?: Date,
    dataConclusao?: Date,
    dataAprovacao?: Date,
    descricao?: string,
    observacao?: string,
    dataSolicitacao?: Date,

    nomeArquivo1?: string | null,
    nomeArquivo2?: string | null,
    nomeArquivo3?: string | null,
    arquivo1?: File | null,
    arquivo2?: File | null,
    arquivo3?: File | null,

  ): Promise<number> {
    const result = await this.repository.createManutencao(
      nroManutencao,
      idManutencao,
      status,
      idCentroCusto,
      idMaquinaEquip,
      idFuncionarioSolicitante,
      idFuncionarioAprovacao,
      idFornecedorResponsavel,
      valorOrcamento,
      dataPrevConclusao,
      dataConclusao,
      dataAprovacao,
      descricao,
      observacao,
      dataSolicitacao,
      nomeArquivo1,
      nomeArquivo2,
      nomeArquivo3,
      arquivo1,
      arquivo2,
      arquivo3,
    );

    return result;
  }
}
